export default function (value) {
  if(!value) return '';
  // Capitalize each word
  return value.replace(/([^\W_]+[^\s-]*) */g, function(s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
  });
}